<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box" v-show="!out">
          <div>
            <el-form-item label="姓名：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
            <el-form-item label="身份证：" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入身份证"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 20px;">地区：</label>
          </div>
          <div style="margin-right:10px">  
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <!-- <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div> -->
          <div>
            <el-form-item label="审核起始日期：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.startTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="审核结束日期：">
              <el-date-picker
                style="width:193px;"
                value-format="timestamp"
                v-model="form.endTime"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })"
                icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
        <div class="input-box" v-show="out">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace2" @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form1.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form1,callback:_d => tableData1 = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit" v-show="!out">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('pxbthshfbt')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._p"></file_Upload></el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/培训补贴和生活费补贴--导入.xls" download="培训补贴和生活费补贴.xls">下载模板</a> -->
        下载模板
      </el-button>
    </div>
    <el-button v-if="showBtn[5].isShow" type="primary" @click="out = !out" icon="el-icon-document-remove">{{out===false?'导出报表':'数据采集'}}</el-button>
    <div class="edit" v-show="out">
      <el-button type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table" v-show="!out">
      <el-table
        :data="tableData"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index"
          :prop="item.key"
          :fixed="index>7?false:true"
          width='100px'
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <div class="table" v-show="out">
      <el-table
        :data="tableData1"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo1"
          :key="index"
          :prop="item.key"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="培训补贴和生活费补贴"
      :visible.sync="centerDialogVisible"
      :modal="false"
      @close="close"
      width="1400px"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" ref="editForm" :rules="rules" size="mini" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item label="培训机构名称：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="申报状态：">
                          <el-select size="mini" filterable v-model="editForm.applyStatus" placeholder="请选择">
                            <el-option
                              v-for="item in $public.shengbaozhuangtai"
                              :key="item.label"
                              :label="item.label"
                              :value="item.label">
                            </el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item label="补贴申报地：">
                          <el-input style="width:193px;" v-model="editForm.allowanceArea"></el-input>
                        </el-form-item>
                        <el-form-item label="申请培训人数(人)：">
                          <el-input style="width:193px;" v-model.number="editForm.trainingAllowanceCount"></el-input>
                        </el-form-item>
                        <el-form-item label="申请培训补贴金额(元)：">
                          <el-input style="width:193px;" v-model.number="editForm.trainingAllowanceFee"></el-input>
                        </el-form-item>
                        <el-form-item label="申请培训人数(人)：">
                          <el-input style="width:193px;" v-model.number="editForm.lifeAllowanceCount"></el-input>
                        </el-form-item>
                        <el-form-item label="申请生活费补贴金额(元)：">
                          <el-input style="width:193px;" v-model.number="editForm.lifeAllowanceFee"></el-input>
                        </el-form-item>
                        <el-form-item prop="ownerName" label="法定代表人：">
                          <el-input style="width:193px;" v-model="editForm.ownerName"></el-input>
                        </el-form-item>
                        <el-form-item prop="idCard" label="身份证号：">
                          <el-input style="width:193px;" v-model="editForm.idCard"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="户名：">
                          <el-input style="width:193px;" v-model="editForm.bankUserName"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行：">
                          <el-input style="width:193px;" v-model="editForm.bankName"></el-input>
                        </el-form-item>
                        <el-form-item label="银行账号：">
                          <el-input style="width:193px;" v-model="editForm.bankNo"></el-input>
                        </el-form-item>
                        <el-form-item label="经办人：">
                          <el-input style="width:193px;" v-model="editForm.dealPerson"></el-input>
                        </el-form-item>
                        <el-form-item label="经办人电话：">
                          <el-input style="width:193px;" v-model="editForm.dealPhone"></el-input>
                        </el-form-item>
                        <el-form-item label="录入人：">
                          <el-input style="width:193px;" v-model="editForm.inputContentUser"></el-input>
                        </el-form-item>
                        <el-form-item label="审核人：">
                          <el-input style="width:193px;" v-model="editForm.auditUser"></el-input>
                        </el-form-item>
                        <el-form-item label="审核时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.auditTime"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>

<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/trainingAllowance',
      form:{},
      type:'16',
      centerDialogVisible:false,
      tableData:[],
      tableData1:[],
      selectRow:[],					

      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key: 'name', value: '培训机构名称'},
        {key: 'applyStatus', value: '申报状态'},
        {key: 'allowanceArea', value: '补贴申报地'},
        {key: 'trainingAllowanceCount', value: '申请培训补贴人数(人)'},
        {key: 'trainingAllowanceFee', value: '申请培训补贴金额(元)'},
        {key: 'lifeAllowanceCount', value: '申请生活费补贴人数(人)'},
        {key: 'lifeAllowanceFee', value: '申请生活费补贴金额(元)'},
        {key: 'ownerName', value: '法定代表人'},
        {key: 'idCard', value: '身份证号'},
        {key: 'phone', value: '联系电话'},
        {key: 'bankUserName', value: '户名'},
        {key: 'bankName', value: '开户银行'},
        {key: 'bankNo', value: '银行账号'},
        {key: 'dealPerson', value: '经办人'},
        {key: 'dealPhone', value: '经办人联系电话'},
        {key: 'inputContentUser', value: '录入人'},
        {key: 'auditUser', value: '审核人'},
        {key: 'auditTime', value: '审核时间'},
      ],
      baseInfo1:[
        {key: 'areaName', value: '行政区划'},
        {key: 'organizationCount', value: '机构数量'},
        {key: 'allowanceCount', value: '补贴人数(人)'},
        {key: 'trainingAllowanceFee', value: '培训补贴金额(元)'},
        {key: 'lifeAllowanceFee', value: '生活费补贴金额(元)'},
        {key: 'totalAllowanceFee', value: '补贴总金额（元）'},
      ],
      isCreate:false,
      out:false,
      rules:{
        ownerName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
    }
  },
  created() {
    this.isShowBtn("TrainingAllowance")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.auditTime = new Date(newForm.auditTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create(this.api,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
              
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change(`${this.api}/modify`,newForm).then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>

<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>